import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { ChevronDownOutlinedIcon } from 'components/atoms/icons/chevron-down-outlined';
import { PeopleIcon } from 'components/atoms/icons/people';
import { DateFormats } from 'infrastructure/enums';
import { DateFormatter } from 'infrastructure/functions';
import PatientSelectBox from 'components/molecules/patient-select-box';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { IBaseSelectBoxOption } from 'components/atoms/base-select-box/types';
import type { PatientSelect } from 'infrastructure/classes/select/patient-select';

interface IProps {
  patients: PatientSelect[];
  patientGuid: string;
  isUnknownNumber: boolean;
  onChange: (val: string) => void;
}

const PatientSelection: React.FC<IProps> = (props) => {
  const { patients, patientGuid, isUnknownNumber, onChange } = props;

  const { t } = useTranslation();

  const patientOptions = useMemo<IBaseSelectBoxOption[]>(() => {
    return patients.map((el) => ({
      value: el.guid,
      label: `${el.label} ${DateFormatter({
        date: el.birthDate,
        format: DateFormats['MM-dd-yyyy'],
      })}`,
    }));
  }, [patients]);

  return (
    <div className={classNames(s.patients, isUnknownNumber && s.unknown)}>
      {isUnknownNumber ? (
        <PatientSelectBox
          placeholder={t('labels.searchPatient')}
          labelRender={(el) => {
            const date = DateFormatter({
              date: el.record?.birthDate,
              format: DateFormats['MM-dd-yyyy'],
              toUTC: true,
            });
            return `${el.label} ${date}`;
          }}
          prefix={<ChevronDownOutlinedIcon />}
          icon={<PeopleIcon className={s.icon} count={patientOptions.length} />}
          maxWidth="280px"
          value={patientGuid}
          onChange={onChange}
          size="large"
          plaintext
          allowSearch
        />
      ) : (
        <BaseSelectBox
          prefix={<ChevronDownOutlinedIcon />}
          icon={<PeopleIcon className={s.icon} count={patientOptions.length} />}
          maxWidth="280px"
          value={patientGuid}
          options={patientOptions}
          onChange={onChange}
          size="large"
          plaintext
          allowSearch
        />
      )}
    </div>
  );
};

export default PatientSelection;
